module.exports = __webpack_public_path__ + "static/img/banner_f004.96c1029.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner_f004.jpg
// module id = ggkn
// module chunks = 40